import React from 'react'

import Banner from './components/Banner'
import ControleNaPalma from './components/ControleNaPalma'
import Comeceagora from './components/ComeceAgora'
import OndeUsar from './components/OndeUsar'
import NascemosParaFacilitar from './components/NascemosParaFacilitar'
import TagVeloe from './components/TagVeloe'
import Planos from './components/Planos'
import { useFetchContent } from 'src/hooks/useContentful/useFetchContent'
import Loading from 'src/components/Loading'
import { ApolloProvider } from '@apollo/client'
import { client } from 'src/services/apollo'
import { useAuth } from 'src/services/api/auth'

function Parcerias() {
	const { data, isLoading } = useFetchContent()
	const token = useAuth()

	if (isLoading || !data || token.isLoading || !token.data) return <Loading />

	const landingOrder = data.fields.landingSections.map(
		section => section.sys.contentType.sys.id
	)

	const pages = {
		landingHeader: <Banner />,
		landingDefaultPromo: <Planos />,
		landingSimpleSection: <ControleNaPalma />,
		landingStepperSection: <Comeceagora />,
		landingMapa: <OndeUsar />,
		landingDoubleSection: <NascemosParaFacilitar />,
		landingSecaoTagVeloe: <TagVeloe />
	}

	return (
		<ApolloProvider client={client}>
			{landingOrder
				.filter(section => pages.hasOwnProperty(section))
				.map(section => (
					<div key={section}>{pages[section]}</div>
				))}
		</ApolloProvider>
	)
}

export default Parcerias
